/**
 * The number of days within which an item is considered "recently updated".
 * Items updated within this window get a visual badge in list views.
 * Keep this in sync with the RECENT_DAYS constant in e2e-tests/tests/recently-updated-mark.spec.ts.
 */
export const RECENT_DAYS = 30;

/**
 * Returns true if the given date falls within the last RECENT_DAYS days.
 */
export function isRecentlyUpdated(date: Date | string | null | undefined): boolean {
    if (!date) return false;
    const d = typeof date === 'string' ? new Date(date) : new Date(date as Date);
    const cutoff = new Date();
    cutoff.setDate(cutoff.getDate() - RECENT_DAYS);
    return d > cutoff;
}
